import React from "react";
import StoreIcon from "@mui/icons-material/Store";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import RestaurantIcon from "@mui/icons-material/Restaurant";
import MuseumIcon from "@mui/icons-material/Museum";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import WcIcon from "@mui/icons-material/Wc";
import MoneyIcon from "@mui/icons-material/Money";
import InfoIcon from "@mui/icons-material/Info";
import HotelIcon from "@mui/icons-material/Hotel";
import SchoolIcon from "@mui/icons-material/School";
import LocalLibraryIcon from "@mui/icons-material/LocalLibrary";

export default function PoiIcon({ poi }) {
    let icon = "";
    if (poi.tags.tourism) {
        const { tourism } = poi.tags;
        if (tourism === "attraction") icon = <AccountBalanceIcon />;
        if (tourism === "museum") icon = <MuseumIcon />;
        if (tourism === "information") icon = <InfoIcon />;
        if (tourism === "hotel") icon = <HotelIcon />;
    }
    if (poi.tags.amenity) {
        const { amenity } = poi.tags;
        if (amenity === "restaurant") icon = <RestaurantIcon />;
        if (amenity === "townhall") icon = <BusinessCenterIcon />;
        if (amenity === "courthouse") icon = <BusinessCenterIcon />;
        if (amenity === "toilets") icon = <WcIcon />;
        if (amenity === "bank") icon = <MoneyIcon />;
        if (amenity === "place_of_worship") icon = <AccountBalanceIcon />;
        if (amenity === "school") icon = <SchoolIcon />;
        if (amenity === "library") icon = <LocalLibraryIcon />;
    }
    if (poi.tags.shop) {
        icon = <StoreIcon />;
    }
    if (poi.tags.office) {
        icon = <BusinessCenterIcon />;
    }

    return <>{icon}</>;
}
